<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

/**
 * We map this to the global store state.
 * Assuming your store has a 'request' module or a global 'loading' state.
 */
const ajaxRequestInProgress = computed(() => {
    // Adjusted to check the central 'request' state or similar Vuex flag
    return store.state.request?.ajaxRequestInProgress || false;
});
</script>

<template>
    <div
        v-if="ajaxRequestInProgress"
        class="ajax-loader"
    />
</template>

<style scoped>
.ajax-loader {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    animation: glowingLine 500ms infinite;
}

@keyframes glowingLine {
    0% {
        background-color: #fff;
    }
    50% {
        background-color: aqua;
    }
    100% {
        background-color: #fff;
    }
}
</style>